module.exports = __webpack_public_path__ + "static/media/dice-d20.398ad41b.svg";